/* eslint no-param-reassign: "error" */
import {
  Route,
  Routes,
} from 'react-router';
import {
  selection,
} from 'redux-resource-plugins';
import {
  getStatus,
} from 'redux-resource';
import {
  shallowEqual,
  useDispatch,
  useSelector,
} from 'react-redux';

import {
  ResourceType,
} from '@gymcloud/core';
import {
  getUiState,
} from 'web-selectors';
import {
  uiActions,
} from 'web-actions';
import {
  Spinner,
} from 'web-components';
import {
  Flex,
} from 'web-styled';

import Individuals from './Individuals';
import Groups from './Groups';
import Archived from './Archived';

const mapState = (state => ({
  readStatus: getStatus(
    state,
    [
      // 'clients.requests.fetchClients.status',
      'clientGroups.requests.fetchClientGroups.status',
      // 'archivedClients.requests.fetchArchivedClients.status',
    ],
    true,
  ),
  openedTooltips: getUiState('openedTooltips')(state),
}));

const ClientsPage = () => {
  const dispatch = useDispatch();

  const {
    readStatus,
    openedTooltips,
  } = useSelector(mapState, shallowEqual);

  const onChecked = ({
    resourceType,
    selectedIds,
    id,
  }: {
    resourceType: ResourceType,
    selectedIds: number[],
    id: number,
  }) => {
    if (selectedIds.includes(id)) {
      dispatch(selection.deselectResources(resourceType, [id]));
    } else {
      dispatch(selection.selectResources(resourceType, [id]));
    }
  };

  return (
    <Flex
      fillSpace
    >
      {readStatus.succeeded && (
        <Routes>
          <Route
            path="individuals/:page?"
            element={(
              <Individuals
                openedTooltips={openedTooltips}
                onChecked={onChecked}
                onRequestAdd={() => {
                  const newState: any = {
                    addClientModal: true,
                  };
                  if (openedTooltips.some(el => el.key === 'add_client')) {
                    newState.openedTooltips = openedTooltips.filter(el => el.key !== 'add_client');
                  }
                  dispatch(
                    uiActions.setUiState(newState),
                  );
                }}
              />
            )}
          />
          <Route
            path="groups"
            element={(
              <Groups
                onChecked={onChecked}
                openedTooltips={openedTooltips}
                onRequestAdd={() => {
                  dispatch(
                    uiActions.setUiState({
                      addGroupModal: true,
                    }),
                  );
                }}
              />
            )}
          />
          <Route
            path="customers"
            element={(
              <Individuals
                isCustomer
                openedTooltips={openedTooltips}
                onChecked={onChecked}
              />
            )}
          />
          <Route
            path="archived"
            element={(
              <Archived
                onChecked={onChecked}
              />
            )}
          />
        </Routes>
      )}

      {readStatus.pending && (
        <Spinner message="Loading..." />
      )}
    </Flex>
  );
};

export default ClientsPage;
